import { ThemeProperties } from '../../core';

export interface NotificationAlertTheme {
	basePadding: string;
	baseBorderRadius: string;
	baseText: string;
	baseIconMargin: string;

	infoBorderColor: string;
	infoBackground: string;
	infoTextColor: string;
	infoIconColor: string;

	successBorderColor: string;
	successBackground: string;
	successTextColor: string;
	successIconColor: string;

	warningBorderColor: string;
	warningBackground: string;
	warningTextColor: string;
	warningIconColor: string;

	dangerBorderColor: string;
	dangerBackground: string;
	dangerTextColor: string;
	dangerIconColor: string;
}

export const theme = new ThemeProperties('notificationAlert');
